// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__33e6h","dragIcon":"Choice_dragIcon__1OC_b","left":"Choice_left__1h4yP","input":"Choice_input__3i1Gk"};